import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { invalidateKeys, queryKeys } from '@/lib/query-keys';

interface UseDeletePackageOptions {
  /** Off for bulk deletes, which raise one summary toast instead. */
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}

export const useDeletePackage = (options?: UseDeletePackageOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (packageId: string) =>
      apiClient.delete(`packages/${packageId}`),
    onSuccess: () => {
      invalidateKeys(queryClient, queryKeys.packages.all());
      if (options?.showSuccessToast !== false) toast.success('Package deleted');
    },
    onError: (error: Error) => {
      if (options?.showErrorToast !== false) {
        toast.error(error.message || 'Failed to delete package');
      }
    },
  });

  return {
    deletePackage: mutation.mutate,
    deletePackageAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
};
